export {
  default as getRequestParentContactFormInputs,
  getRequestParentContactOnValidate,
} from './getRequestParentContactFormInputs'
